import 'css-chunksrc/client/scenes/costProfileRemoval/styles.scss';export default {
  "header": "_header_1jq9q_1",
  "group": "_group_1jq9q_5",
  "text": "_text_1jq9q_9",
  "name": "_name_1jq9q_14",
  "main": "_main_1jq9q_20",
  "buttons": "_buttons_1jq9q_27"
};